import "@fortawesome/fontawesome-svg-core/styles.css";
import axios from "axios";
import { useAtom } from "jotai";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "@fortawesome/fontawesome-svg-core/styles.css";
import DateConverter from "utils/DateConverter";
import { filtersAtomObject, originalDataAtomObject, expandedJobDetailsAtomObject} from "../../state";
import CandidateAPI from "services/CandidateService";
import useJobDetails from "../../hooks/useJobDetails";
import { Link } from "react-router-dom";
import "./Jobs.scss";

const Jobs = ({ lastJobItemRef }) => {
  const [originalData, setOriginalData] = useAtom(originalDataAtomObject);
  const [filters] = useAtom(filtersAtomObject);
  const { commute } = filters;
  const { t } = useTranslation();
  const { jobs } = originalData;
  const [expandedJobDetails] = useAtom(expandedJobDetailsAtomObject);

  const jobDetails = useJobDetails();

  const api = axios.create({
    baseURL: process.env.REACT_APP_PUBLIC_GATEWAY_URL,
    crossDomain: true,
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const updateOriginalData = (job, flag) => {
    setOriginalData({
      ...originalData,
      jobs: originalData.jobs.map((x) =>
        x.id === job.id ? { ...job, bookmarked: flag } : x
      ),
    });
  };

  const handleBookmark = async (job) => {
    updateOriginalData(job, "progress");
    var response = await CandidateAPI.bookmark(job);
    if (response && response.data && response.data.succeeded) {
      updateOriginalData(job, true);
    } else {
      updateOriginalData(job, false);
    }
  };

  const handleUnbookmark = async (job) => {
    updateOriginalData(job, "progress");
    var response = await CandidateAPI.unbookmark(job);
    if (response && response.data && response.data.succeeded) {
      updateOriginalData(job, false);
    } else {
      updateOriginalData(job, true);
    }
  };

  return (
    <>
      {jobs
        ?.filter((x) => x.id > 0)
        .map((item, index) => (
          <li
            className={`job-data ${item.bookmarked === true ? "in-shortlists" : ""}`}
            id={`job-${item.id > 0 ? item.id : item.slug}`}
            key={index}
          >
            {(item.url === "" || !item.url) ? (
              <Link
                to={`?job=${item.slug}`}
                // to={`?job=${item.slug}&override=https%3A%2F%2Ftest-third-party-careers-site.devstaging.wearevennture.co.uk`}
                state={{ job: item }}
              >
                <Row className="justify-content-between">
                  <Col>
                    <span className="post-date">
                      <DateConverter dateValue={item.postDate} />
                    </span>
                  </Col>
                 <Col
  xs="auto"
  className={`${item.bookmarked === true || item.bookmarked === false || item.bookmarked === "progress" ? "ref-bookmark" : ""}`}
>
  <span className="job-ref">{item.reference}</span>

  
</Col>
                </Row>
                <div className="xs-heading">
                  <span>{item.title}</span>
                </div>
                <ul className="job-data-highlights">
                  <li>
                    <i className="icon money"></i>
                    <span>{item.salaryText}</span>
                  </li>
                  <li>
                    <i className="icon location"></i>
                    <span>{item.location?.address}</span>
                  </li>
                  <li>
                    <i className="icon type"></i>
                    <span>{item.jobTypes?.map((x) => x).join(", ")}</span>
                  </li>
                  {item.commuteTime > 0 && (
                    <li>
                      <i className={`icon commute ${commute?.method?.name}`}></i>
                      <span>
                        {item.commuteTime} {t("mins")}
                      </span>
                    </li>
                  )}
                </ul>
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      item.searchSnippet === ""
                        ? item.description
                        : item.searchSnippet,
                  }}
                ></p>
              </Link>
            ) : (
              <a href={item.url}>
                <Row className="justify-content-between">
                  <Col>
                    <span className="post-date">
                      <DateConverter dateValue={item.postDate} />
                    </span>
                  </Col>
                  <Col
                    xs="auto"
                    className={`${item.bookmarked === true || item.bookmarked === false || item.bookmarked === "progress" ? "ref-bookmark" : ""}`}
                  >
                    <span className="job-ref">{item.reference}</span>
                    {item.bookmarked === true && (
    <button
      className="add-to-shortlist"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleUnbookmark(item); }}
    >
      <i className="fa-solid fa-heart"></i>
    </button>
  )}
  {item.bookmarked === false && (
    <button
      className="add-to-shortlist"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleBookmark(item); }}
    >
      <i className="fa-regular fa-heart"></i>
    </button>
  )}
  {item.bookmarked === "progress" && (
    <button className="add-to-shortlist" disabled>
      <i className="fa-solid fa-spinner fa-spin"></i>
    </button>
  )}
                  </Col>
                </Row>
                <div className="xs-heading">
                  <span>{item.title}</span>
                </div>
                <ul className="job-data-highlights">
                  <li>
                    <i className="icon money"></i>
                    <span>{item.salaryText}</span>
                  </li>
                  <li>
                    <i className="icon location"></i>
                    <span>{item.location?.address}</span>
                  </li>
                  <li>
                    <i className="icon type"></i>
                    <span>{item.jobTypes?.map((x) => x).join(", ")}</span>
                  </li>
                  {item.commuteTime > 0 && (
                    <li>
                      <i className={`icon commute ${commute?.method?.name}`}></i>
                      <span>
                        {item.commuteTime} {t("mins")}
                      </span>
                    </li>
                  )}
                </ul>
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      item.searchSnippet === ""
                        ? item.description
                        : item.searchSnippet,
                  }}
                ></p>
              </a>
            )}
          
          </li>
        ))}
    </>
  );
};




export default Jobs;
